<dialog class="chat-window" [attr.aria-label]="headerTitle() | translate">
  <header class="chat-window__header">
    <div class="chat-window__brand">
      <span class="chat-window__icon-well">
        <nova-icon name="rocket_assist_chat" [size]="32"></nova-icon>
      </span>
      <h2 class="chat-window__title">{{ headerTitle() | translate }}</h2>
    </div>
    <div class="chat-window__header-actions">
      <button type="button"
              class="chat-window__icon-button"
              [attr.aria-label]="'help-faq.MINIMIZE' | translate"
              (click)="minimize.emit()">
        <nova-icon name="minimize" [size]="24"></nova-icon>
      </button>
      <button type="button"
              class="chat-window__icon-button"
              [attr.aria-label]="'help-faq.CLOSE' | translate"
              (click)="closed.emit()">
        <nova-icon name="close" [size]="24"></nova-icon>
      </button>
    </div>
  </header>

  <ng-template #rootChipsRow>
    <div class="chat-window__chips chat-window__chips chat-window__chips--row">
      @for (chip of rootChips(); track chip.id) {
      <button type="button"
              class="chat-window__chip chat-window__chip--root"
              [class.chat-window__chip--active]="chip.id === selectedRootChipId()"
              [disabled]="chipsDisabled()"
              (click)="onChipClick(chip)">
        {{ resolveChipLabel(chip) | translate }}
      </button>
      }
    </div>
  </ng-template>

  <div class="chat-window__root">
    @if (rootChips().length && selectedRootChipId() !== '') {
    <ng-container *ngTemplateOutlet="rootChipsRow"></ng-container>
    }
  </div>

  <div class="chat-window__body">

    <p class="chat-window__disclaimer">
      {{ 'help-faq.DISCLAIMER' | translate }}
      <a class="chat-window__disclaimer-link" [href]="privacyLinkHref()">{{ 'help-faq.PRIVACY_POLICY' | translate }}</a>.
    </p>

    @for (item of items(); track $index) {
    @if (isBubble(item)) {
    <div class="chat-window__bubble-row"
         [class.chat-window__bubble-row--user]="item.kind === 'user'">
      <div class="chat-window__bubble"
           [class.chat-window__bubble--bot]="item.kind === 'bot'"
           [class.chat-window__bubble--user]="item.kind === 'user'">

        @switch (item.text) {

        @case('copies') {
          @if (displayFundingTransfer()) {
          <div>
            <p class="qa-list__answer">
              <span>
                {{ 'help-faq.answers.copies.displayFundingTransfer' | translate }}
              </span>
            </p>
          </div>
          }
          @else {
          <div>
            <p class="qa-list__answer">
              <span>
                {{ 'help-faq.answers.copies.DEFAULT' | translate }}
              </span>
            </p>
          </div>
          }
        }

        @case('who') {
          @if (!participantsLoading() && borrowerNames().length) {
          <div>
            <p class="qa-list__answer">
              {{ 'help-faq.answers.who' | translate }}
            </p>

            <div class="qa-list__answer">
              <ul>
                @for (borrower of borrowerNames(); track borrower.id) {
                <li appHighlightData>{{ borrower.firstName }} {{ borrower.lastName }} ({{ borrower.roleDisplay | translate }})</li>
                }
                @for (participant of participantNames(); track participant.id) {
                <li appHighlightData>{{ participant.firstName }} {{ participant.lastName }} ({{ participant.roleDisplay | translate }})</li>
                }
              </ul>
            </div>
          </div>
          }
        }

        @case ('proof') {
        <div>
          <p class="qa-list__answer">
            {{ 'help-faq.answers.proof' | translate }}
          </p>
        </div>
        }

        @case ('nbthsign') {
        @if (hasNbthParticipants()) {
        <div>
          <p class="qa-list__answer">
            {{ 'help-faq.answers.nbthsign' | translate }}
          </p>
        </div>
        }
        }

        @case ('autopay') {
        <div>
          <p class="qa-list__answer">
            {{ 'help-faq.answers.autopay' | translate }}
          </p>
        </div>
        }

        @case ('discrepancies') {
        <div>
          <p class="qa-list__answer">
            <span>{{ 'help-faq.CLOSING_TEAM_INTRO' | translate }} </span>
            <a class="qa-list__answer-phone" href="tel:8888485309">{{ 'help-faq.CLOSING_TEAM_PHONE' | translate }}</a>
          </p>
        </div>
        }

        @case ('escrow') {
        <div>
          <p class="qa-list__answer">
            {{ 'help-faq.answers.escrow' | translate }}
          </p>
        </div>
        }

        @case('fundsdueatclosing') {
          @if (cashToCloseFinalIsFromBorrower() === true) {
          <div>
            @if(displayFundingTransfer()) {
            <p class="qa-list__answer">
              {{ 'help-faq.answers.fundsdueatclosing.displayfundingtransfer.INTRO' | translate }}
              <a href="https://www.rocketclose.com/funding/funding-transfers" target="_blank" rel="noopener noreferrer">{{ 'help-faq.answers.fundsdueatclosing.displayfundingtransfer.LINK' | translate }}</a>{{ 'help-faq.answers.fundsdueatclosing.displayfundingtransfer.OUTRO' | translate }}
            </p>
            } @else {
            <p class="qa-list__answer">
              {{ 'help-faq.answers.fundsdueatclosing.DEFAULT' | translate }}
            </p>
            }
          </div>
          }
        }

        @case ('incorrect') {
        <div>
          <p class="qa-list__answer">
            <span>{{ 'help-faq.CLOSING_TEAM_INTRO' | translate }} </span>
            <a class="qa-list__answer-phone" href="tel:8888485309">{{ 'help-faq.CLOSING_TEAM_PHONE' | translate }}</a>
          </p>
        </div>
        }

        @case('loaninfo') {
          @if (hasData()) {
          <div>
            @if(disbursementDate() !== '') {
            <p class="qa-list__answer">
              {{ 'help-faq.loanTerms.DISBURSEMENT_DATE' | translate }} <span appHighlightData>{{disbursementDate()}}</span>
            </p>
            }

            @if(interestRate() !== '') {
            <p class="qa-list__answer">
              {{ 'help-faq.loanTerms.INTEREST_RATE' | translate }} <span appHighlightData>{{interestRate()}}</span>
            </p>
            }

            @if(monthlyPayment() !== '') {
            <p class="qa-list__answer">
              {{ 'help-faq.loanTerms.MONTHLY_PAYMENT' | translate }} <span appHighlightData>{{monthlyPayment()}}</span>
            </p>
            }

            @if(firstPaymentDate() !== '') {
            <p class="qa-list__answer">
              {{ 'help-faq.loanTerms.FIRST_PAYMENT_DATE' | translate }} <span appHighlightData>{{firstPaymentDate()}}</span>
            </p>
            }

            @if(prepaymentPenalty() !== '') {
            <p class="qa-list__answer">
              {{ 'help-faq.loanTerms.PREPAYMENT_PENALTY' | translate }} <span appHighlightData>{{prepaymentPenalty()}}</span>
            </p>
            }
          </div>
          }
        }

        @case('payoffs') {
          @if(payoffs().length) {
          <div>
            @if(disbursementDate() !== '') {
            <p class="qa-list__answer">
              {{ 'help-faq.answers.payoffs.DISBURSEMENT_INTRO' | translate }} <span appHighlightData>{{disbursementDate()}}</span>.
            </p>
            }

            <p class="qa-list__answer">
              {{ 'help-faq.answers.payoffs.CREDITOR' | translate }}
            </p>


            @for (payoff of payoffs(); track payoff.recipient) {
            <div class="qa-list__answer">
              <p appHighlightData>{{ payoff.recipient }}</p>
              <p appHighlightData>{{ payoff.amount | currency }}</p>
            </div>
            }
          </div>
          }
        }

        @case('morethaniowe') {
          @if(cashToCloseFinalIsFromBorrower() === false) {
          <div>
            <p class="qa-list__answer">
              {{ 'help-faq.answers.morethaniowe' | translate }}
            </p>
          </div>
          }
        }

        @default {
          @if (showMissing) {
          {{ translateBubble(item) }}
          }
        }

        }
      </div>

    </div>

    <!-- main menu  rootChips -->
    @if (rootChips().length && selectedRootChipId() === '') {
    <ng-container *ngTemplateOutlet="rootChipsRow"></ng-container>
    }

    }
    @if (isTyping(item)) {
    <div class="chat-window__bubble-row">
      <div class="chat-window__bubble chat-window__bubble--bot chat-window__typing" [attr.aria-label]="'help-faq.ASSISTANT_TYPING' | translate">
        <span class="chat-window__typing-dot"></span>
        <span class="chat-window__typing-dot"></span>
        <span class="chat-window__typing-dot"></span>
      </div>
    </div>
    }
    }

    @if (chips().length) {
    <div class="chat-window__chips" [class.chat-window__chips--row]="chipsDirection() === 'row'">
      @for (chip of chips(); track chip.id) {
      <button type="button"
              class="chat-window__chip"
              [disabled]="chipsDisabled()"
              (click)="onChipClick(chip)">
        {{ chip.label | translate }}
      </button>
      }
    </div>
    }
  </div>
</dialog>
